module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "vm-select-dropdown__item",
    class: {
      'selected': _vm.itemSelected,
      'disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
        'hover': _vm.parent.hoverIndex === _vm.index
    },
    on: {
      "mouseenter": _vm.hoverItem,
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectOptionClick($event)
      }
    }
  }, [_vm._t("default", [_c('span', [_vm._v(_vm._s(_vm.currentLabel))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c746f844","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/option.vue
// module id = 39
// module chunks = 0